import React from 'react';
import { Box, Typography, Divider } from '@mui/material';


export default function Maintenance({ inProgress }) {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#d3d3d3',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    height: '190px',
                    backgroundColor: '#084F76',
                    padding: 4,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <Typography color="white" sx={{ fontSize:"28px", fontFamily: "Segoe UI, sans-serif" }}>
                    Down for Maintenance.
                </Typography>
            </Box>

            <Box
                sx={{
                    width: '100%',
                    backgroundColor: 'white',
                    padding: 2,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                }}
            >
                <Box sx={{ width: 150, display: 'flex', justifyContent: 'center' ,marginRight: 4 }}>
                    <img
                        src="/images/nexelus-logo-200.png"
                        alt="Nexelus Logo"
                        style={{ height: 48, objectFit: 'contain' }}
                    />
                </Box>

                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ borderColor: '#ccc', marginX: 2 }}
                />

                <Typography
                    variant="caption"
                    color="textSecondary"
                    align="left"
                    sx={{ fontSize: '10px' ,fontFamily: "Segoe UI, sans-serif" }}
                >
                    Copyright 1993-{ currentYear } Paradigm Software Technologies. All rights reserved.
                    <br />
                    This program is protected by US and International copyright laws.
                </Typography>
            </Box>
        </Box>
    );
}
